// extracted by mini-css-extract-plugin
module.exports = {"Cards":"Cards_Cards__GVyc2","Cards--exit":"Cards_Cards--exit__2FDyd","Card":"Cards_Card__3X24H","CardImage":"Cards_CardImage__D8h-Z"};